import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevronWithPeriod",
  "use": "chevronWithPeriod-usage",
  "viewBox": "0 0 26 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 24\" id=\"chevronWithPeriod\"><path d=\"M10 10l4 4 4-4\" stroke=\"#031425\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><circle cx=\"1.25\" cy=\"16\" r=\"1.125\" fill=\"#031425\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol